import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Grid from '@material-ui/core/Grid';
import Spin from 'components/Spin';
import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { useObservable } from 'react-use-observable';
import { Space } from 'v2/components/Shared/Space';
import TopPage from 'v2/components/Shared/TopPage';
import eduzzAccountsService from 'v2/services/eduzzAccount';

export default function ZapierNew() {
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
  const [betaModules] = useObservable(() => eduzzAccountsService.getBetaModules(), []);
  if (!user || !Array.isArray(betaModules)) return null;
  if (!betaModules.includes('zapier')) return <Redirect to='/producer/dashboard' />;
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Breadcrumbs aria-label='breadcrumb'>
          <strong>Zapier</strong>
          <Link to='/producer/zapier'>Minhas Integrações</Link>
          <p>Nova integração</p>
        </Breadcrumbs>
        <Space axis='vertical' size={16} />
        <TopPage title='Criar Nova Integração' />
      </Grid>
      <Grid item xs={12}>
        <React.Suspense fallback={<Spin />}>
          <zapier-app-directory app='eduzz' link-target='new-tab' theme='light' introcopy='hide' create-without-template='hide' use-this-zap='show' />
        </React.Suspense>
      </Grid>
    </Grid>
  );
}
